<template>
    <div class="visit-object">
      <title-bar :title="$t('Gattaran_0_Select_Contact_UrRS' /** 选择联系人 */)" showBack @back="back" />
      <rich-load-list
        ref="scroll"
        class="visit-object-list-wrapper"
        :pull-down-refresh="false"
        :pull-up-load="false"
      >
        <ul class="visit-object-list" v-if="visitObjectList.length">
          <li
            :class="[{
              'visit-object-list-item' : true,
              'selected': item.roleId === selectedPerson.roleId
            }]"
            @click="select(item)"
            v-for="(item, index) in visitObjectList" :key="index"
          >
            <rich-card>
              <h3 slot="header" class="item-header">
                <em class="contact-name">{{ item.name }}</em>
                <span class="contact-role">{{ item.roleDesc }}</span>
                <i class="crm-Icon_edit" @click.stop="toEdit(item)"></i>
              </h3>
              <ul slot="body" class="item-body">
                <li v-if="item.isPrimary">
                  <rich-tag class="primary-person-tag">{{ $t('Internal_Tools_App_tpZf_wbHM' /** 主要联系人 */) }}</rich-tag>
                </li>
                <li class="contact-phone">
                  <i class="crm-Icon-phone"></i>
                  <span v-if="item.phone">{{ item.phone }}</span>
                  <span class="phone-error" v-else>{{ $t('Gattaran_form_hRvn_xomV'/** 电话是必填的 */) }}</span>
                </li>
                <li class="contact-time">
                  <i class="icon-filled_history"></i>
                  <span v-for="(time, timeIdx) in item.contactTime" :key="timeIdx">
                    {{ time.startTime }}-{{ time.endTime }}
                  </span>
                </li>
                <li class="contact-way">
                  <i class="icon-filled_collected"></i>
                  <span>
                    {{ item.contactMode && item.contactMode.length
                      ? item.contactMode.map(mode => {
                          return mode.value || ''
                        }).join('; ')
                        : ''
                      }}
                  </span>
                </li>
              </ul>
            </rich-card>
            <div class="item-selected-icon">
              <i class="crm-icon-claimed"></i>
            </div>
          </li>
        </ul>
        <div class="no-person" v-if="loading === false && !visitObjectList.length">
          <i class="crm-icon_tips"></i>
          <span>{{ $t('Gattaran_0_No_contacts_EeBR' /** 没有联系人 */) }}</span>
        </div>
        <!-- 已设置3个联系人则无法再新增 -->
        <rich-button v-if="visitObjectList.length < 3" class="add-visit-object-btn" @click="toAdd">
          <i class="crm-Icon-claim"></i>
          <span>{{ $t('Gattaran_0_Create_new_Faau' /** 新建联系人 */) }}</span>
        </rich-button>
      </rich-load-list>
      <div class="confirm">
        <rich-button class="confirm-btn" @click="confirm" :disabled="!selectedPerson.roleId">
          <span>{{ gettext('确定') }}</span>
        </rich-button>
      </div>
    </div>
  </template>

  <script type="text/ecmascript-6">
  import TitleBar from '@/components/TitleBar'
  import { getVisitObjectInit } from '../../service'
  import Vue from 'vue'
  import AddVisitObject from '../AddVisitObject/index.vue'

  Vue.use(AddVisitObject)

  export default {
    name: 'VisitObjectList',
    components: {
      TitleBar
    },
    props: {
      options: {}
    },
    data () {
      return {
        loading: false,
        bizoppId: this.$route.query.bizoppId,
        visitObjectList: [],
        selectedPerson: {}
      }
    },
    computed: {
      roleList () {
        return this.options.roleId?.enum || []
      },
      contactModeList () {
        return this.options.contactMode?.enum
      }
    },
    methods: {
      fetchVisitObject () {
        this.loading = true
        const loading = this.$createToast({ mask: true })
        loading.show()

        getVisitObjectInit({
          bizoppId: this.bizoppId,
          pageSize: 5
        }).then(res => {
          const {
            contactModeList,
            visitObjectList
          } = res
          const  processedData = visitObjectList.map(item => {
              const contactModeObj = item.contactMode.map(mode => {
                return contactModeList.find(contactMode => contactMode.key === mode);
              });
              return { ...item, contactMode: contactModeObj };
            });
          this.visitObjectList = processedData.sort((a, b) => b.isPrimary - a.isPrimary) || []
          this.loading = false
          loading.hide()
        })
      },
      select (item) {
        if (item.roleId !== this.selectedPerson.roleId) {
          this.selectedPerson = item
        } else {
          this.selectedPerson = {}
        }
      },
      toAdd () {
        const addInstance = this.$createGasAddVisitObjectPopup({
          $props: {
            options: this.options,
            isEdit: false
          },
          $events: {
            back: () => addInstance.remove(),
            save: this.fetchVisitObject
          }
        }).show()
      },
      toEdit (item) {
        const editInstance = this.$createGasAddVisitObjectPopup({
          $props: {
            options: this.options,
            roleId: item.roleId,
            isEdit: true
          },
          $events: {
            back: () => editInstance.remove(),
            save: this.fetchVisitObject
          }
        }).show()
      },
      confirm () {
        const selectedRoleId = this.selectedPerson.roleId
        const selectedPersonInfo = this.visitObjectList.find(person => person.roleId === selectedRoleId)
        this.$emit('confirm', selectedPersonInfo)
        console.log('confirm', selectedPersonInfo)
      },
      back () {
        this.$emit('back')
      },
      getContactModeByKey (key) {
        return this.contactModeList.find(mode => mode.key === key)
      }
    },
    created () {
      this.fetchVisitObject()
    }
  }
  </script>

  <style lang="scss" scoped>
  .visit-object {
    position: relative;
    height: 100%;

    .list-loading {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 272px;
    }

    .no-person {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      margin: 24px 0;
      height: 272px;
      padding: 32px 24px 40px 24px;
      box-sizing: border-box;
      border-radius: 16px;
      background-color: #FFFFFF;

      i {
        width: 64px;
        height: 64px;
        color: #B5B5B5;
        font-size: 64px;
      }

      span {
        margin-top: 8px;
        font-size: 28px;
        color: #595C66;
        text-align: center;
        line-height: 36px;
      }
    }

    &-list-wrapper {
      padding: 0 24px 120px 24px;
      background-color: #F2F3F6;
      height: calc(100vh - 100px - 152px - var(--barheight));
      box-sizing: border-box;
    }

    &-list {
      overflow: hidden;

      &-item {
        position: relative;
        margin: 24px 0;
        height: 272px;
        padding: 32px 24px 40px 24px;
        box-sizing: border-box;
        border-radius: 16px;
        background-color: #FFFFFF;
        overflow: hidden;

        .item-selected-icon {
          visibility: hidden;
        }

        &.selected {
          @include border-1px(#F76A31, 16px, solid);

          .item-selected-icon {
            visibility: visible;
            position: absolute;
            bottom: 0;
            right: 0;
            height: 56px;
            width: 56px;
            background-image: linear-gradient(135deg, #FFFFFF 0, #FFFFFF 50%, #F76A31 51%, #F76A31 100%);

            .crm-icon-claimed {
              position: absolute;
              right: 4px;
              bottom: 5px;
              font-size: 20px;
              color: #FFFFFF;
            }
          }
        }

        .item-header {
          display: flex;
          justify-content: flex-start;
          align-items: center;

          .contact-name {
            font-family: DiDiSans-Pro-Medium;
            font-size: 36px;
            font-style: normal;
            color: #282B33;
            line-height: 44px;
            padding-right: 10px;
            max-width: 40%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            text-align: left;
          }
          .contact-role {
            position: relative;
            font-size: 32px;
            color: #8D9099;
            line-height: 40px;
            padding-left: 10px;
            max-width: 40%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            text-align: left;

            &::before {
              position: absolute;
              top: 0;
              left: 0;
              content: '';
              display: block;
              height: 40px;
              width: 1PX;
              background-color: #E9EAEE;
            }
          }
          .crm-Icon_edit {
            position: absolute;
            right: 24px;
            display: flex;
            justify-content: flex-end;
            font-size: 48px;
          }
        }

        .item-body {
          padding-top: 12px;
          .phone-error {
            color: #f93c32;
          }
          li {
            font-family: DiDiSans-Pro-Regular;
            font-size: 28px;
            color: #282B33;
            line-height: 36px;
            padding-top: 12px;
            text-align: left;

            i {
              color: #8D9099;
              padding-right: 16px;
              font-size: 24px;
            }

            .primary-person-tag {
              height: 54px;
              line-height: 54px;
              padding: 4px 19px;
              border-radius: 24px;
              ::v-deep .rich-tag {
                opacity: 0.1;
                background: #8D9099;
              }
              ::v-deep .rich-tag-text {
                  font-size: 24px;
                  font-weight: 400;
                  color: #8D9099;
                }
            }
          }
        }
      }
    }

    ::v-deep .add-visit-object-btn {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 80px;
      border-radius: 16px;
      text-align: center;
      background: #fff;

      i {
        font-size: 24px;
        color: #282B33;
      }
      span {
        padding-left: 16px;
        font-size: 32px;
        color: #282B33;
        font-weight: 400;
      }
    }

    .confirm {
      background-color: #FFFFFF;
      padding: 20px 24px 40px 24px;
      &-btn {
        font-family: DiDiSans-Pro-Bold;
        font-size: 32px;
        color: #FFFFFF;
        text-align: center;
        line-height: 40px;
      }
    }
  }
  </style>
